import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateCategoryAction } from '../../actions/menuItemsAction';

const MenuCategoryRenameDialog = ({
  category,
  openDialog,
  setOpenDialog,
  updateCategoryAction,
}) => {
  const closeDialog = () => {
    setCategoryName('');
    setOpenDialog(false);
  };

  const [categoryName, setCategoryName] = useState(category.category);
  const [inputError, setInputError] = useState(null);

  const submit = (event) => {
    event.preventDefault();

    if (categoryName === category.category) {
      closeDialog();
      return;
    }

    if (!categoryName) {
      setInputError('Please enter a category name.');
      return;
    }
    if (inputError) {
      setInputError(null);
    }

    updateCategoryAction(category.category, categoryName);

    closeDialog();
  };

  return (
    <Dialog
      open={openDialog}
      onClose={closeDialog}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>Category Name</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description' style={{ marginBottom: '1rem' }}>
          Please note empty category list will not be saved unless there is at least one menu item
          added.
        </DialogContentText>

        <form id='create-category-form' noValidate autoComplete='off' onSubmit={submit}>
          <TextField
            id='category-name'
            label='Category Name'
            placeholder='eg. Mains, Entrees'
            variant='outlined'
            fullWidth
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(inputError)}
            helperText={inputError}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} color='default'>
          Cancel
        </Button>
        <Button onClick={submit} color='primary' autoFocus>
          Save Category
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({ updateCategoryAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MenuCategoryRenameDialog);
